import React from "react";
import {
  Button,
  Typography,
  Link,
  LinearProgress,
  Box,
} from "@material-ui/core";
import PropTypes from "prop-types";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";

export default function DownloadBar(props) {
  const getDlink2 = (target) => {
    props.setEventSource(new EventSource(target));
  };

  const pdfCreate = () => {
    if (props.progress == 100) {
      return "PDF " + props.t("dlFinish");
    } else if (props.progress >= 1) {
      return "PDF " + props.t("dlCreate");
    } else {
      return "";
    }
  };

  const dlTarget = props.endpoint + "dl/" + props.dlName;

  return (
    <Typography component={"div"}>
      <Box mb={1}>
        <Button
          variant="contained"
          startIcon={<GetAppOutlinedIcon fontSize="small" />}
          disabled={props.disabled}
          onClick={() => getDlink2(props.target)}
        >
          {props.t("create")} PDF
        </Button>
      </Box>
      {props.progress == 100 && (
        <Box mb={1}>
          <Link underline="none" href={dlTarget} target="_blank" rel="noopener">
            <Button
              startIcon={<GetAppOutlinedIcon fontSize="small" />}
              variant="contained"
            >
              Download PDF
            </Button>
          </Link>
        </Box>
      )}
      <LinearProgress variant="determinate" value={props.progress} />
      {props.progress >= 1 && (
        <Typography fontSize={5}>
          {Math.round(props.progress)} % {" " + "-" + " "}
          {pdfCreate()}
        </Typography>
      )}
    </Typography>
  );
}

DownloadBar.propTypes = {
  dlTarget: PropTypes.string,
};